var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import LinkCss from "./LinkCss.js";
class Link extends s {
  constructor() {
    super(...arguments);
    __publicField(this, "_formatHref", () => {
      if (this.url.includes(":")) {
        return this.url;
      } else {
        return `#${this.url}`;
      }
    });
  }
  static get styles() {
    return [LinkCss];
  }
  static get properties() {
    return {
      text: { type: String },
      icon: { type: String },
      url: { type: String },
      target: { type: String }
    };
  }
  render() {
    const icon = isEmpty(this.icon) ? "" : y`<i class="icon ${this.icon}"></i>`;
    const isContainer = isEmpty(this.icon) && isEmpty(this.text);
    const content = isContainer ? y`<slot></slot>` : y`${icon}${this.text}`;
    if (isEmpty(this.url)) {
      return y`
        <style>@import '${iscecoWidgetLibrary.iconCss}';</style>
        <span id="link-element" class="${isContainer ? "container" : "link"}">
          ${content}
        </span>
      `;
    } else {
      return y`
        <style>@import '${iscecoWidgetLibrary.iconCss}';</style>
        <a id="link-element"
           class="${isContainer ? "container" : "link"}"
           href="${this._formatHref()}"
           @click="${(e) => this._click(e)}"
           target="${isEmpty(this.target) ? "_self" : this.target}">
          ${content}
        </a>
      `;
    }
  }
  _click(event) {
    const targetIsSelf = !this.target || this.target === "_self";
    if (this.url && targetIsSelf && !event.ctrlKey && !checkNavigationAllowed({ newURL: this._formatHref() })) {
      event.preventDefault();
    }
  }
}
customElements.define("isceco-link", Link);
export { Link as default };
